import { RemoteConfigVariables } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { Dimensions, Image, ImageSourcePropType, StyleSheet, Text, View } from 'react-native';
import GroupWorkoutBackground from '../assets/images/group-workout-background.png';
import FBLogo from '../assets/images/powered-by-fitillion-logo.png';
import NutritionBackground from '../assets/images/nutrition-background1.png';
import TrackingBackground from '../assets/images/tracking-background1.png';
import WelcomeBackground from '../assets/images/welcome2-background.png';
import WorkoutBackground from '../assets/images/workout-background1.png';
import Theme from '../theme';
import { FirebaseConfigText, Slider, SliderImage } from '../ui';
import { defaultScale } from '../utils/scaling';
interface IProps {
  t: (key: string, options?: any) => string;
  inviterImageSource: ImageSourcePropType | null;
}

export const WelcomeImageSlider: FunctionComponent<IProps> = ({ t, inviterImageSource }) => {
  const { width } = Dimensions.get('window');
  const firstSliderImage = inviterImageSource ?? WorkoutBackground;
  return (
    <Slider>
      <View style={styles.slideContainer}>
        <SliderImage source={firstSliderImage} />
        <View style={styles.detailContainer}>
        <View style={[styles.headerContainer, { width }]}>
          <Image source={FBLogo} style={styles.logo} />
        </View>
          <FirebaseConfigText
            style={[styles.headerText, { marginTop: 25, fontSize: 25 }]}
            remoteConfigKey={RemoteConfigVariables.welcome_screen_heading}
          />
          <View style={[styles.descriptionTextContainer, { width }]}>
            <Text style={styles.descriptionText}>
              {t('personalisedWorkoutsNutritiongGoalTracking')}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.slideContainer}>
        <SliderImage source={WelcomeBackground} />
        <View style={styles.detailContainer}>
          <View style={[styles.headerContainer, { width }]}>
            <Text style={[Theme.textStyle.heading, styles.headerText]}>
              {t('workoutHeader')}
            </Text>
          </View>
          <View style={[styles.descriptionTextContainer, { width }]}>
            <Text style={styles.descriptionText}>{t('workoutText')}</Text>
          </View>
        </View>
      </View>
      <View style={styles.slideContainer}>
        <SliderImage source={NutritionBackground} />
        <View style={styles.detailContainer}>
          <View style={[styles.headerContainer, { width }]}>
            <Text style={[Theme.textStyle.heading, styles.headerText]}>
              {t('nutritionHeader')}
            </Text>
          </View>
          <View style={[styles.descriptionTextContainer, { width }]}>
            <Text style={styles.descriptionText}>{t('nutritionText')}</Text>
          </View>
        </View>
      </View>
      <View style={styles.slideContainer}>
        <SliderImage source={TrackingBackground} />
        <View style={styles.detailContainer}>
          <View style={[styles.headerContainer, { width }]}>
            <Text style={[Theme.textStyle.heading, styles.headerText]}>
              {t('trackingHeader')}
            </Text>
          </View>
          <View style={[styles.descriptionTextContainer, { width }]}>
            <Text style={styles.descriptionText}>{t('trackingText')}</Text>
          </View>
        </View>
      </View>
      <View style={styles.slideContainer}>
        <SliderImage source={GroupWorkoutBackground} />
        <View style={styles.detailContainer}>
          <View style={[styles.headerContainer, { width }]}>
            <Text style={[Theme.textStyle.heading, styles.headerText]}>
              {t('groupHeader')}
            </Text>
          </View>
          <View style={[styles.descriptionTextContainer, { width }]}>
            <Text style={styles.descriptionText}>{t('groupText')}</Text>
          </View>
        </View>
      </View>
    </Slider>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    backgroundColor: Theme.WHITE,
  },
  slideContainer: {
    height: '100%',
  },
  logo: {
    width: defaultScale(180),
    height: defaultScale(70),
    resizeMode: 'contain',
  },
  footer: {
    padding: defaultScale(15),
  },
  environmentSelector: {
    paddingHorizontal: 15,
    backgroundColor: Theme.GREY,
  },
  buttonStyle: {
    marginVertical: 5,
    maxWidth: defaultScale(410),
    width: '100%',
  },
  buttonTextStyle: {
    fontFamily: Theme.Custom700,
  },
  headerText: {
    paddingTop: defaultScale(20),
  },
  headerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: defaultScale(70),
  },
  descriptionText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    marginTop: defaultScale(10),
    paddingHorizontal: defaultScale(25),
  },
  descriptionTextContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  detailContainer: {
    marginVertical: defaultScale(20),
  },
});
